/* eslint-disable no-console */
import Pusher from 'pusher-js'
import FeedContentService from '@/app-domains/feed/feed.service'
import UserInteractionsService from '../../../../services/user.interactions.service'
import getEnvironmentConfiguration from '../../../../config'
import { getAccessToken } from '@/core/http/auth.api'
import store from '@/core/store'
import { unsetNotification, setNotification } from '@/core/store/Slices/NotificationsSlice'
import threadsService from '@/app-domains/threads/threads.service'
import boxesService from '@/app-domains/boxes/boxes.service'
import labelsService from '@/app-domains/labels/labels.service'

class NotificationService {
  constructor () {
    this.setProvider()
    this.subscribed = false
    this.messageHandler = this.messageHandler.bind(this)
  }

  subscribe () {
    const meStatus = store.getState().me
    if (!this.subscribed) {
      const channel = this.provider.subscribe(`private-${meStatus.me.id}`)
      channel.bind('message', this.messageHandler)
      channel.bind('pusher:subscription_error', console.error)
      this.subscribed = true
    }
  }

  resetProvider () {
    const meStatus = store.getState().me
    this.setProvider()
    this.subscribed = false
    try {
      this.provider.unsubscribe(`private-${meStatus.me.id}`)
      this.provider.disconnect()
    } catch (e) {
        
    }
    this.subscribe()
  }

  setProvider () {
    const config = getEnvironmentConfiguration()
    this.provider = new Pusher(
      config.REACT_APP_PUSHER_APP_KEY,
      {
        authEndpoint: config.REACT_APP_PUSHER_AUTH_ENDPOINT,
        cluster: config.REACT_APP_PUSHER_CLUSTER,
        encrypted: true,
        auth: {
          headers: {
            Authorization: getAccessToken()
          }
        }
      },
    )
  }

  setPlayNotificationFn (playNotificationFn) {
    this.playNotificationFn = playNotificationFn
  }

  async messageHandler (_data) {
    await FeedContentService.getLastFeedRelatedEntities(false)
    const lastThread = threadsService.getLastThread()
    const message = threadsService.getHeadMessageOfThread(lastThread)
    if (!message?.boxid) return
    const box = boxesService.findBoxbyId(message.boxid)

    const labels = labelsService.findLabelsForBox(box)
    if (!labels || labels.length === 0) return
    if (labels.filter(l => l.showninfeed).length > 0) {
      this.playNotificationFn()
      if (UserInteractionsService.hasUserScrolledMoreThan(100)) {
        this.toggleNotificationVisibility(true, message)
      }
    }
  }

  removeNotification () {
    store.dispatch(unsetNotification())
  }
  
  toggleNotificationVisibility (show, messageData) {
    if (!show) {
      this.removeNotification()
      store.commit('NOTIFICATIONS:toggle', false)
    } else if (document.querySelector('.feed-header')?.getBoundingClientRect().top < -100 && messageData) {
      store.dispatch(setNotification({ messageData }))
      store.commit('NOTIFICATIONS:toggle', show)
    }
  }
}

export default new NotificationService()
